export class QCNamingConvention {
  aspectRatio: string;
  domesticEpisode: string;
  elementType: string;
  foreignEpisode: string;
  format: string;
  houseNumber: string;
  language: string;
  programTitle: string;
  revision: string;
  standard: string;
  status: string;
  version: string;
  videoBitRate: string;
  videoBitRateUnits: string;

  constructor(init?:Partial<QCNamingConvention>) {
    if (init.aspectRatio != null) {
      this.aspectRatio = this.formatted(init.aspectRatio)
        .replace(/_[A-Z]+$/, '');
    }
    this.domesticEpisode = this.formatted(init.domesticEpisode);
    this.elementType = init.elementType;
    this.foreignEpisode = this.formatted(init.foreignEpisode);
    this.format = this.formatted(init.format);
    this.houseNumber = this.formatted(init.houseNumber);
    let language = this.formatted(init.language)
    if (language != null) {
      this.language = language
        // Replace slashes with underscores
        .replace(/[\/]+/g,'_')
        // Remove last parentheses group
        .replace(/_\([A-Z]+\)$/, '')
        // Remove any remaining parentheses
        .replace(/[\(\)]+/g,'');
    }
    let programTitle = this.formatted(init.programTitle)
    if (programTitle != null) {
      let match = programTitle.match(/\((\w+)\)$/);
      this.programTitle = match != null ? match[1] : null;
    }
    this.revision = init.revision;
    let standard = this.formatted(init.standard);
    if (standard != null) {
      // Remove any parentheses
      this.standard = standard.replace(/[\(\)]+/g,'');
    }
    this.status = this.formatted(init.status);
    this.videoBitRate = init.videoBitRate;
    if (init.videoBitRateUnits != null) {
      this.videoBitRateUnits = init.videoBitRateUnits.toLowerCase();
    }
    let version = this.formatted(init.version);
    if (version != null) {
      let match = version.match(/\((\w+)\)$/);
      this.version = match != null ? match[1] : null;
    }
  }

  get description(): string {
    return '';
  }

  get generatedName(): string {
    return '';
  }

  private formatted(component: any): string {
    if (component == null) { return null };
    return component.toUpperCase().replace(/[\s\-]/g,'_').replace(/[\.\:]/g,'')
  }

  static get requiredComponents(): string[] {
    return [];
  }

  static hasAllRequiredComponents(components: Partial<QCNamingConvention>): boolean {
    for (let component of this.requiredComponents) {
      let value = components[component];
      if (value == null || value.trim() == '') {
        return false
      }
    }
    return true;
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-naming-convention.ts